export default "__VITE_ASSET__CyJor6$1__"